/** @jsx jsx */
import * as React from "react";
import type { ThemeUIStyleObject } from "theme-ui";
import { jsx } from "theme-ui";

interface ButtonProps extends React.ComponentProps<"button"> {
  sx?: ThemeUIStyleObject;
}

const Button: React.FC<ButtonProps> = ({ sx, ...restProps }) => {
  return (
    <button
      type="button"
      sx={{
        fontFamily: "body",
        fontSize: 3,
        variant: "buttons.primary",
        py: 2,
        px: 3,
        lineHeight: 1.4,
        cursor: "pointer",
        border: 0,
        ...sx,
      }}
      {...restProps}
    />
  );
};

export default Button;
